

import productsJson from '../../json/products.json';

export default {
  filterProductsByCategory({commit, state}, id) {
    /** This is the action hook of filter, filter products by category id
     * Here is must be your database functionality
     */

    let products = productsJson.filter(data => data.cat === id);

    commit('SET_PRODUCTS', products)
  },
  searchProduct({commit, state}, search) {
    /** This is the action hook of search,  search products by user input
     * Here is must be your database functionality
     */

    let products = productsJson;
    if(search) {
      products = products.filter(data => data.title.toLowerCase().includes(search.toLowerCase()));
    }
    commit('SET_PRODUCTS', products);
  }
}



// WEBPACK FOOTER //
// ./src/store/products/actions.js